import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-25a29acc")

_pushScopeId("data-v-25a29acc")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Tickets")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = {
  key: 0,
  class: "no_tickets_container"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "no_tickets" }, "Nessun tickets da visualizzare", -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "tickets_type_switcher_container" }
const _hoisted_8 = { class: "tickets_type_switcher" }
const _hoisted_9 = { class: "tickets_container opened_tickets" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "download_document" }
const _hoisted_12 = { class: "info" }
const _hoisted_13 = { class: "document_info" }
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "project" }
const _hoisted_16 = { class: "date_container" }
const _hoisted_17 = { class: "data data_creation" }
const _hoisted_18 = {
  key: 1,
  class: "no_selected_ticket"
}
const _hoisted_19 = {
  key: 0,
  class: "tickets_container opened_tickets"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "tickets_type_title" }, "Tickets da gestire", -1)
const _hoisted_21 = { class: "download_document" }
const _hoisted_22 = { class: "info" }
const _hoisted_23 = { class: "document_info" }
const _hoisted_24 = { class: "title" }
const _hoisted_25 = { class: "project" }
const _hoisted_26 = { class: "date_container" }
const _hoisted_27 = { class: "data data_creation" }
const _hoisted_28 = {
  key: 1,
  class: "tickets_container closed_tickets"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "tickets_type_title" }, "Tickets chiusi", -1)
const _hoisted_30 = { class: "download_document" }
const _hoisted_31 = { class: "info" }
const _hoisted_32 = { class: "document_info" }
const _hoisted_33 = { class: "title" }
const _hoisted_34 = { class: "project" }
const _hoisted_35 = { class: "date_container" }
const _hoisted_36 = { class: "data data_creation" }
const _hoisted_37 = { class: "data data_creation" }
const _hoisted_38 = { class: "tickets_container opened_tickets" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "tickets_type_title" }, "Controlla i tickets non assegnati", -1)
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "download_document" }
const _hoisted_42 = { class: "info" }
const _hoisted_43 = { class: "document_info" }
const _hoisted_44 = { class: "title" }
const _hoisted_45 = { class: "project" }
const _hoisted_46 = {
  key: 1,
  class: "no_selected_ticket"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadTickets()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                (!$setup.tickets.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _hoisted_5
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode("div", _hoisted_7, [
                        _createVNode("div", _hoisted_8, [
                          _createVNode("div", {
                            class: ["type", { active: $setup.showAssegnati }],
                            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.setActiveTickets('assegnati')))
                          }, " Miei ticket ", 2),
                          _createVNode("div", {
                            class: ["type", { active: $setup.showLiberi }],
                            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.setActiveTickets('liberi')))
                          }, " Non assegnati ", 2)
                        ])
                      ]),
                      _withDirectives(_createVNode("div", null, [
                        _createVNode("div", _hoisted_9, [
                          _createVNode(_component_Calendar, {
                            value: $setup.date,
                            "is-expanded": "",
                            attributes: $setup.setAttributes,
                            "disabled-dates": { weekdays: [1, 7] },
                            onDayclick: $setup.dayClicked,
                            class: "calendar_container"
                          }, null, 8, ["value", "attributes", "onDayclick"]),
                          ($setup.currentTicketsToShow.length != 0)
                            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.currentTicketsToShow, (ticket) => {
                                  return (_openBlock(), _createBlock("div", {
                                    key: ticket.tickets_id,
                                    class: "ticket",
                                    style: {
                                        borderLeft: `4px solid ${ticket.tickets_status_color}`,
                                    },
                                    onClick: ($event: any) => ($setup.openDetail(ticket))
                                  }, [
                                    _createVNode("div", _hoisted_11, [
                                      _createVNode("div", _hoisted_12, [
                                        _createVNode("div", _hoisted_13, [
                                          _createVNode("div", _hoisted_14, "#" + _toDisplayString(ticket.tickets_id) + " - " + _toDisplayString(ticket.tickets_subject), 1),
                                          _createVNode("div", _hoisted_15, _toDisplayString(ticket.projects_name ? ticket.projects_name : ""), 1),
                                          _createVNode("div", _hoisted_16, [
                                            _createVNode("div", _hoisted_17, "Aperto " + _toDisplayString($setup.dateFormat(ticket.tickets_creation_date)), 1),
                                            (ticket.tickets_assign_date)
                                              ? (_openBlock(), _createBlock("div", {
                                                  key: 0,
                                                  class: ["data", $setup.expiredTicket(ticket.tickets_assign_date)]
                                                }, " Assegnato " + _toDisplayString($setup.dateFormat(ticket.tickets_assign_date)), 3))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ])
                                    ])
                                  ], 12, ["onClick"]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_18, " Nessun ticket assegnato per il " + _toDisplayString($setup.selectedDay ? $setup.dateFormat($setup.selectedDay.id) : $setup.dateFormat($setup.date)), 1))
                        ]),
                        ($setup.openedTickets && $setup.openedTickets.length != 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_19, [
                              _hoisted_20,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.openedTickets, (ticket) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: ticket.tickets_id,
                                  class: "ticket",
                                  style: {
                                    borderLeft: `4px solid ${ticket.tickets_status_color}`,
                                },
                                  onClick: ($event: any) => ($setup.openDetail(ticket))
                                }, [
                                  _createVNode("div", _hoisted_21, [
                                    _createVNode("div", _hoisted_22, [
                                      _createVNode("div", _hoisted_23, [
                                        _createVNode("div", _hoisted_24, "#" + _toDisplayString(ticket.tickets_id) + " - " + _toDisplayString(ticket.tickets_subject), 1),
                                        _createVNode("div", _hoisted_25, _toDisplayString(ticket.projects_name ? ticket.projects_name : ""), 1),
                                        _createVNode("div", _hoisted_26, [
                                          _createVNode("div", _hoisted_27, "Creato " + _toDisplayString($setup.dateFormat(ticket.tickets_creation_date)), 1),
                                          (ticket.tickets_assign_date)
                                            ? (_openBlock(), _createBlock("div", {
                                                key: 0,
                                                class: ["data", $setup.expiredTicket(ticket.tickets_assign_date)]
                                              }, " Assegnato " + _toDisplayString($setup.dateFormat(ticket.tickets_assign_date)), 3))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ])
                                  ])
                                ], 12, ["onClick"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        ($setup.closedTickets && $setup.closedTickets.length != 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_28, [
                              _hoisted_29,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.closedTickets, (ticket) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: ticket.tickets_id,
                                  class: "ticket",
                                  style: {
                                    borderLeft: `4px solid ${ticket.tickets_status_color}`,
                                },
                                  onClick: ($event: any) => ($setup.openDetail(ticket))
                                }, [
                                  _createVNode("div", _hoisted_30, [
                                    _createVNode("div", _hoisted_31, [
                                      _createVNode("div", _hoisted_32, [
                                        _createVNode("div", _hoisted_33, "#" + _toDisplayString(ticket.tickets_id) + " - " + _toDisplayString(ticket.tickets_subject), 1),
                                        _createVNode("div", _hoisted_34, _toDisplayString(ticket.projects_name ? ticket.projects_name : ""), 1),
                                        _createVNode("div", _hoisted_35, [
                                          _createVNode("div", _hoisted_36, "Creato " + _toDisplayString($setup.dateFormat(ticket.tickets_creation_date)), 1),
                                          _createVNode("div", _hoisted_37, "Chiuso " + _toDisplayString($setup.dateFormat(ticket.tickets_close_date)), 1)
                                        ])
                                      ])
                                    ])
                                  ])
                                ], 12, ["onClick"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 512), [
                        [_vShow, $setup.showAssegnati]
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_38, [
                        _hoisted_39,
                        ($setup.ticketsNotAssigned && $setup.ticketsNotAssigned.length != 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_40, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ticketsNotAssigned, (ticket) => {
                                return (_openBlock(), _createBlock("div", {
                                  key: ticket.tickets_id,
                                  class: "ticket",
                                  style: {
                                    borderLeft: `4px solid ${ticket.tickets_status_color}`,
                                },
                                  onClick: ($event: any) => ($setup.openDetail(ticket))
                                }, [
                                  _createVNode("div", _hoisted_41, [
                                    _createVNode("div", _hoisted_42, [
                                      _createVNode("div", _hoisted_43, [
                                        _createVNode("div", _hoisted_44, "#" + _toDisplayString(ticket.tickets_id) + " - " + _toDisplayString(ticket.tickets_subject), 1),
                                        _createVNode("div", _hoisted_45, _toDisplayString(ticket.projects_name ? ticket.projects_name : ""), 1),
                                        _createVNode("div", {
                                          class: ["data", $setup.expiredTicket(ticket.tickets_assign_date)]
                                        }, " Aperto il " + _toDisplayString($setup.dateFormat(ticket.tickets_creation_date)), 3)
                                      ])
                                    ])
                                  ])
                                ], 12, ["onClick"]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_46, " Non ci sono ticket da gestire "))
                      ], 512), [
                        [_vShow, $setup.showLiberi]
                      ])
                    ]))
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})